import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const eventsTableTooltips = TOOLTIPS_TEXTS.eventsTable;

export const BASE_EVENTS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_EVENTS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_EVENTS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'description', 'phases', 'divisions', 'communities', 'options'],
  displayedTitles: [
    'Name',
    'Description',
    'Phase(s)',
    'Division(s)',
    'Assigned Communities',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: false },
    { sorting: false },
    { sorting: false }
  ],
  displayedTooltips: [
    eventsTableTooltips.name,
    eventsTableTooltips.description,
    eventsTableTooltips.phases,
    eventsTableTooltips.divisions,
    eventsTableTooltips.communities
  ],
  options: null,
  dataSource: []
};
